import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ForgotService } from "../shared/Forgot.Service";
import { AppInsightsService } from "../shared/AppInsights.Service";

@Component({
  selector: "app-identity-mgt",
  templateUrl: "./identity-mgt.component.html",
  styleUrls: ["./identity-mgt.component.scss"]
})
export class IdentityMgtComponent implements OnInit {
  // public display = true;
  // public client = false;
  // categories: {};
  brokers: {};
  public isCes: boolean = false;
  public isEqh: boolean = false;
  selection = { name: "" };
  brokerList = "";
  showContent: boolean;
  constructor(
    private router: Router,
    public forgotService: ForgotService,
    private appInsightsService: AppInsightsService
  ) {
    this.brokers = [
      { broker_id: 1, name: "Broker", val: "ebb" },
      //{ broker_id: 2, name: 'GA' , val: 'ebga'},
      { broker_id: 3, name: "Account Manager", val: "ebam" }
    ];
  }

  ngOnInit() {
    window.scroll(0, 0);
    this.showContent = false;
    this.appInsightsService.logPageView("Forgot UI Page View");

    if (this.router.url.indexOf('ces') !== -1) {
      this.isCes = true;
    } else {
      this.isEqh = true;
    }
  }

  show() {
    this.showContent = !this.showContent;
  }

  redirect(userType: string) {
    if (userType) {
      // client forgot
      if (userType === "client") {
        this.router.navigate(["/client"]);
      }
      if (userType === "advisor") {
        this.forgotService.setType("apwd");
        this.router.navigate(["/a"]);
      }
      if (userType === "broker") {
        this.forgotService.lifeInsurance = false;
        this.router.navigate(["/broker"]);
      }
      if (userType === "life-broker") {
        this.forgotService.lifeInsurance = true;
        this.router.navigate(["/broker"]);
      }
      if (userType === "ebb") {
        this.router.navigate(["/eb"]);
      }
      if (userType === "ebga" || userType === "ebam") {
        // ga and account manager
        this.router.navigate(["/ebbga"]);
      }
      if (userType === "ebe") {
        this.router.navigate(["/ebe"]);
      }
      if (userType === "consultant") {
        this.router.navigate(["/consultant"]);
      }

      // Uncomment navigate below when backend is ready
      if (userType === "epp") {
        this.router.navigate(["/epp"]);
      }
      if (userType === "epac") {
        this.router.navigate(["/epac"]);
      }
      if (userType === "business") {
        this.router.navigate(["/business"]);
      }
      if (userType === "cesclient") {
        this.router.navigate(["/ces/client"]);
      }
      if (userType === "cesagent") {
        this.router.navigate(["/ces/broker"]);
      }
      if (userType === "third party") {
        this.router.navigate(["/fsr"]);
      }
      if (userType === "rgp") {
        if (window.location.origin.indexOf("int-auth.equitable.com") !== -1) {
          window.location.href =
            "https://betaretirementsolutions.financialtrans.com/tf/myPLANCAT/sponLogin:PasswordResetTransEvent$start";
        } else {
          window.location.href =
            "https://retirementsolutions.financialtrans.com/tf/myPLAN/sponLogin:PasswordResetTransEvent$start";
        }
        // this.router.navigate(['/rgp']);
      }
    }
  }
}
